import { profileAPI } from '@/api/careClient';
import { COMMON_ROUTES } from '@/config/route';
import { trackerIsCareClientVisitorProfileInitializedReset } from '../../redux/module/tracker';
export const updateCareClientProfile = async ({ _id, updatedData, dispatch, navigateError, }) => {
    const res = await profileAPI.Update({
        _id,
        updatedData,
    });
    if (res.success) {
        dispatch(trackerIsCareClientVisitorProfileInitializedReset());
    }
    else {
        navigateError(res.errorCode, COMMON_ROUTES.API_ERROR);
    }
    return { isSuccess: res.success };
};
